module.exports = __webpack_public_path__ + "img/abnormal.e2719a9d.png";